import { Component, inject } from '@angular/core';
import { GoToStep } from '../../../../store/onboarding/onboarding.actions';
import { OnboardingSteps } from '../../../../store/onboarding/onboarding.model';
import { Store } from '@ngxs/store';
import { SubscriptionPayload } from '../../../../_interfaces/subscription.interface';
import { Router } from '@angular/router';
import { ProfileDropdownComponent } from '../../../../shared/components/profile-dropdown/profile-dropdown.component';
import { SubscriptionApiService } from '../../../../_services/subscription-service/api/subscription-api-service.service';
import { SubscriptionPackagesComponent } from '../../../../shared/components/subscription-packages/subscription-packages.component';
import { ToastService } from '../../../../_services/toast-service/toast.service';

@Component({
  selector: 'app-subscription-selection',
  imports: [ProfileDropdownComponent, SubscriptionPackagesComponent],
  templateUrl: './subscription-selection.component.html',
})
export class SubscriptionSelectionComponent {
  readonly store = inject(Store);
  readonly subscriptionApiService = inject(SubscriptionApiService);
  readonly router = inject(Router);
  readonly toastService = inject(ToastService);

  constructor() {
    this.store.dispatch(new GoToStep(OnboardingSteps.SUBSCRIPTION_SELECTION));
  }

  handleSelection(data: SubscriptionPayload) {
    this.subscriptionApiService.selectSubscriptionPackage(data).subscribe({
      next: () => {
        this.router.navigate(['/sign-up/business-certificate']);
      },
      error: (err) => {
        if (err.error?.non_field_errors?.[0]?.includes('already exists')) {
          this.toastService.show('You have already selected a package on this account.');
        }
      },
    });
  }
}
